import { z } from 'zod';
import { LiquidJsCustomFilters } from '@dealstack/shared/lib/common/liquidJs/liquidJs.ts';

// eslint-disable-next-line unused-imports/no-unused-vars
const preFillableTemplateFieldShape = z.object({
	id: z.string().optional(),
	fieldKey: z.string(),
	fieldSourceTemplate: z.string().nullish(),
});

export type PreFillableTemplateFieldShape = z.infer<typeof preFillableTemplateFieldShape>;

export const collectCustomDetailDefinitionsIdsFromSourceTemplate = (template: string): string[] => {
	const regex = new RegExp(`${LiquidJsCustomFilters.GET_CUSTOM_DETAIL_VALUE}:\\s*"(.*?)"`, 'g');
	return [...template.matchAll(regex)].map((match) => match[1]);
};
